import type { createClient, NotificationsApi } from '@spazious/client-backoffice';
import { useBackofficeQueryClient } from '@spazious/react-backoffice';

export type ApiClient = ReturnType<typeof createClient> & { notifications: NotificationsApi };

export const useApiClient = (): ApiClient => useBackofficeQueryClient() as unknown as ApiClient;
